export enum FormAction {
    EDIT = 'edit',
    CREATE = 'create',
}
